import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Grid,
    Stack,
    Divider
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import map from "lodash/map";

import get from "lodash/get";
import filter from "lodash/filter";
import find from "lodash/find";
import includes from "lodash/includes";
import InputText from "../../../components/form/InputText";
import AutoComplete from "../../../components/form/AutoComplete";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@mui/icons-material/Save';

import FormatMoney from "../../../components/form/FormatMoney"
import Table from "../../../components/form/Table";
import { getConfiCost } from "../../../store/masters/thunk/costGlobal/getAll";
import { postRouteCost } from "../../../store/transactions/thunk/route/postCost";
import { putRouteCost } from "../../../store/transactions/thunk/route/putCost";

const Alert = ({
    __,
    open,
    close,
    selected,
    setSelected,
    reload,
    setError
}) => {
    const dispatch = useDispatch();
    const idCostRoute = Number(get(selected, "id"));
    const { id } = useParams();

    const [searchValue, setSearchValue] = useState("");
    const [costFilterd, setCostFilterd] = useState([]);

    const current = selected
    const currentRoute = useSelector((state) => state.transactions.route.detail);
    const cost = useSelector(state => state.transactions.cost);
    const put = useSelector(state => state.transactions.route.putCost);
    const post = useSelector(state => state.transactions.route.postCost);
    const user = useSelector(state => state.auth.login.dataUser);
    const customerId = get(currentRoute, "data.customerID");
    const costProvider = useSelector(state => state.transactions.costProvider)
 

    const costsOptions = map(get(costProvider, "data.data", []), ({ id, descriptionCost, price }) => ({
        value: id,
        label: `${descriptionCost} - $${price?.toFixed(2)}`,
    }));

    const costAdded = []
    const costAll = get(cost, "data", [])
    const costFilterdPre = filter(costAll, ({ costId }) => !(find(costAdded, (id) => id === costId)))

    const getDataCost = () => {
        dispatch(getConfiCost());
    }

    const onCloseModal = (r) => {
        setSelected({})
        close()
        if (r === "1") {
            reload()
        }
    }

    useEffect(() => {
        if (!!searchValue) {
            setCostFilterd(
                filter(costFilterdPre, ({ nameCost, amount }) =>
                    includes(nameCost?.toLowerCase(), searchValue)
                )
            )
        } else {
            setCostFilterd(costFilterdPre)
        }
    }, [searchValue, get(costFilterdPre, "length")])


    useEffect(() => {
        getDataCost();
    }, [dispatch]);

    useEffect(() => {
        if (get(post, "isSuccess", false)) { onCloseModal("1") }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    }, [post])

    const onSubmit = (values) => {
        const selectedCost = get(costProvider, "data.data", []).find(c => c.id === get(values, "costRoute"));
        const body = {
            idRoute: Number(id),
            idProvider: Number(get(currentRoute, "data.idProvider")),
            id: Number(get(values, "costRoute")),
            quantity: Number(get(values, "total")),
            price: Number(get(selectedCost, "price", 0)),
            comments: "",
        }
       dispatch(postRouteCost(body))
    }


    const initialValues = {

        costRoute: "",
        total: "",
    }

    return (
        <div>
            <Dialog onClose={close} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {__("labels.6")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                               // validationSchema={validatorTariff(__)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="route-cost-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <AutoComplete
                                                            formik={formik}
                                                            name="costRoute"
                                                            label={__(`formCost.costRoute.label`)}
                                                            placeholder={__(`formCost.CostRoute.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false)}
                                                            options={costsOptions}

                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="total"
                                                            label={__(`formCost.total.label`)}
                                                            placeholder={__(`formCost.total.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false)}
                                                            type="number"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton variant="contained" startIcon={<SaveIcon/>} color="secondary" type="submit" form="route-cost-form" loading={get(post, "isLoading") || get(put, "isLoading")}>{__("action.save")}</LoadingButton>
                    <Button variant='outlined' color="secondary" onClick={onCloseModal} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                </Stack>
            </Dialog>
        </div >
    );
}

export default Alert